function o(r) {
  const n = r.import("formats/link");
  class e extends n {
    static create(s) {
      const t = super.create(s);
      return t.classList.add("custom-link"), t.setAttribute("href", s), t.setAttribute("target", "_blank"), t.setAttribute("data-ignorepreview", "true"), t;
    }
  }
  e.blotName = "link", e.tagName = "a", r.register("formats/link", e, !0);
}
export {
  o as CustomLinkExtension
};
